import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { products, CartItem, CartItemsResponse } from "../../types/types";
import { getCartItems, addToCartThunk, updateCartItemThunk, createOrderThunk } from "../thunk";

interface CartState {
  items: CartItem[];
  totalQuantity: number;
  totalAmount: number;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: CartState = {
  items: [],
  totalQuantity: 0,
  totalAmount: 0,
  status: "idle",
  error: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.totalAmount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCartItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCartItems.fulfilled, (state, action: PayloadAction<CartItemsResponse>) => {
        state.status = "succeeded";
        state.items = action.payload.items;
        state.totalQuantity = action.payload.items.reduce((acc, item) => acc + item.quantity, 0);
        state.totalAmount = action.payload.items.reduce((acc, item) => acc + item.totalPrice, 0);
      })
      .addCase(getCartItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(addToCartThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addToCartThunk.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addToCartThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(updateCartItemThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCartItemThunk.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCartItemThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(createOrderThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createOrderThunk.fulfilled, (state) => {
        state.status = "succeeded";
        state.items = [];
        state.totalQuantity = 0;
        state.totalAmount = 0;
      })
      .addCase(createOrderThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { clearCart } = cartSlice.actions;
export default cartSlice.reducer;
